import { useParams } from "react-router-dom";
import { usePagination } from "@/hooks";
import { GetUserAccountHistoryParams } from "@/redux/apis/userAccount/types";

export const useGetUserAccountHistoryParams = () => {
  const { page, pageSize } = usePagination();
  const { id } = useParams();

  const params: GetUserAccountHistoryParams = {
    id: id ?? "",
    page,
    page_size: pageSize,
  };

  return { params, page, pageSize };
};
